// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"a95489fe","152":"35a42d45","579":"725387aa","670":"eb78d0b1","770":"a354c200"}[chunkId] + ".chunk.js";
};